import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export default function ReviewsChart({ chartData }) {
  const groupBy = function (data, key) {
    return data.reduce(function (carry, el) {
      var group = el[key];
      if (carry[group] === undefined) {
        carry[group] = [];
      }
      carry[group].push(el);
      return carry;
    }, {});
  };

  const base_options = {
    // 기초스타일
    title: {
      style: {
        color: "#111827",
        fontWeight: "bold",
      },
    },
    chart: {
      // 차트 스타일 설정
      type: "line",
      backgroundColor: "transparent",
      plotBorderWidth: 1,
      zoomType: "x",
      borderColor: "#E5E7EB",
    },
    accessibility: {
      enabled: false,
    },
    xAxis: {
      type: "datetime",
      crosshair: true,
      lineColor: "#E5E7EB",
      tickColor: "#E5E7EB",
      labels: {
        style: {
          color: "#374151",
        },
      },
    },
    yAxis: [
      {
        title: {
          text: "건(일)",
          style: {
            color: "#374151",
          },
        },
        gridLineColor: "#E5E7EB",
        labels: {
          style: {
            color: "#374151",
          },
        },
      },
      {
        title: {
          text: "건(월)",
          style: {
            color: "#374151",
          },
        },
        gridLineColor: "transparent",
        opposite: true,
        labels: {
          style: {
            color: "#374151",
          },
        },
      },
    ],

    tooltip: {
      borderRadius: 20,
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      style: {
        color: "#333333",
      },
      shadow: {
        color: 'rgba(0,0,0,0.1)',
        width: 8,
        offsetX: 0,
        offsetY: 2
      },
      borderWidth: 0,
    },
    plotOptions: {
      series: {
        // stacking: "normal",
        turboThreshold: 0,
      },
      // area: {
      //   fillOpacity: 0.1,
      // },
    },
    legend: {
      itemStyle: {
        color: "#374151",
        fontSize: "0.8rem",
      },
      itemHiddenStyle: {
        color: "#9CA3AF",
      },
    },
  };

  const [options, setOptions] = useState(base_options);

  useEffect(() => {
    // chart data 셋업

    const monthlygrouped = groupBy(chartData.data, "month");
    const monthlyData = [];
    for (const month in monthlygrouped) {
      let monthlySum = 0;
      monthlygrouped[month].forEach((item) => {
        monthlySum += item.y;
      });
      monthlyData.push({ x: Date.parse(month), y: monthlySum });
    }

    const data = {
      name: `${chartData.product} @ ${chartData.platform} `,
      data: chartData.data.map((item) => {
        return {
          x: Date.parse(item.x),
          y: item.y,
        };
      }),
    };

    const series = [
      {
        data: data.data,
        name: data.name + "(일)",
        color: "orange",
        marker: {
          radius: 3,
          lineColor: "red",
        },
        lineWidth: 1,
      },
      {
        data: monthlyData,
        name: data.name + "(월)",
        color: "#0EA5E9",
        marker: {
          radius: 3,
          lineColor: "#0284C7",
        },
        lineWidth: 1,
        yAxis: 1,
      },
    ];

    const title = {
      style: {
        color: "#111827",
        fontWeight: "bold",
      },
      text: "",
    };

    setOptions((prev) => {
      const temp = {
        ...prev,
        series,
        title,
      };
      return temp;
    });
  }, [chartData]);

  return (
    <div className="w-full">
      <div>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          constructorType={"chart"}
        />
      </div>
    </div>
  );
}
